export const MEMO_CREW_TYPES = {
  CONTRACTOR_W2: 'CONTRACTOR_W2',
  CONTRACTOR_W9: 'CONTRACTOR W9',
  EMPLOYEE: 'EMPLOYEE',
  AGENCY: 'AGENCY'
};
